import React from 'react';

export function StepOzoSubjectLabel() {
  return <>Subjekt OZO</>;
}
